<template lang="pug">
  FormErrorAlert(
    alert-type="warning"
    :dismissable="false"
    heading="Warning"
    message="The results may not be complete due to restricted data for ICE users."
    v-if="$store.state.account.iceAgent"
  ) 
</template>

<script>
export default {
  name: 'ICEAlert',
}
</script>

<style lang="scss" scoped>
</style>
